import HandIcon from 'assets/images/easyPay/init.svg'
import Header from 'components/headers/addLoan'
import { useLocation, useNavigate } from 'react-router-dom'
import style from './final.module.scss'
import moment from 'jalali-moment'
import useSetFinalOld from '../hooks/useSetFinalOld'
import { loanFeeLabel } from 'utilities/helper/loanInterest'
export default function FinalOldAdd() {
    const { state } = useLocation()
    const navigate = useNavigate()
    const { mutate } = useSetFinalOld()
    return (
        <div className=" h-screen relative">
            <Header title="" />
            <div className=" relative text-sm">
                <img
                    src={HandIcon}
                    alt="hand"
                    className=" mx-auto absolute -top-16 z-50 right-32"
                />

                <div className={style['StyledReceipt']}>
                    <div>
                        <p className=" text-gray-1">واریز به حساب:</p>
                        <p>{state?.payload?.name}</p>
                    </div>
                    <hr className=" my-2" />
                    <div className=" flex justify-between my-2">
                        <p className=" text-gray-1">تعداد اقساط:</p>
                        <p>{state?.payload?.number_of_repayments} قسط</p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" text-gray-1">میزان کارمزد:</p>
                        <p>{loanFeeLabel(state?.payload)}</p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" text-gray-1">نحوه دریافت کارمزد:</p>
                        <p>
                            {state?.payload?.interest_pay_mode === 'lip_ma'
                                ? 'افزودن به هر قسط'
                                : 'کسر از مبلغ وام'}
                        </p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" text-gray-1">نام صندوق:</p>
                        <p>{state?.payload?.fundName}</p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" text-gray-1">اقساط پرداخت شده:</p>
                        <p>
                            {state?.payload?.number_of_repaid_installments} قسط
                        </p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" text-gray-1">تاریخ شروع پرداخت:</p>
                        <p>
                            {state?.payload.pay_date &&
                                moment
                                    .from(state?.payload.pay_date, 'YYYY-MM-DD')
                                    .locale('fa')
                                    .format('YYYY/MM/DD')}
                        </p>
                    </div>

                    <hr className=" my-4" />
                    <div className=" flex justify-between my-2">
                        <p className=" text-gray-1"> مبلغ:</p>
                        <p>
                            {state?.payload?.amount &&
                                Number(
                                    state?.payload?.amount
                                ).toLocaleString()}{' '}
                            تومان
                        </p>
                    </div>
                </div>
            </div>
            <div className=" bottom-10 absolute w-full">
                <div className=" w-full">
                    <div
                        className=" mx-8 rounded-xl  bg-green-1 text-white text-center py-2.5 my-2 cursor-pointer"
                        onClick={() => {
                            const body: IIManagementAddOldPayload = {
                                amount: state?.payload?.amount,
                                interest_pay_mode:
                                    state?.payload?.interest_pay_mode,
                                interest_type: state?.payload?.interest_type,
                                interest_rate: state?.payload?.interest_rate,
                                fixed_interest_amount:
                                    state?.payload?.fixed_interest_amount,
                                installments: state?.response?.installments,
                                moneyPool: state?.payload?.moneyPool,
                                poolShip: state?.payload?.poolShip,
                                number_of_repayments:
                                    state?.payload?.number_of_repayments,
                                pay_date: state?.payload?.pay_date,
                                due_date: state?.payload?.due_date,
                                tag: state?.payload?.tag,
                                number_of_repaid_installments: Number(
                                    state?.payload
                                        ?.number_of_repaid_installments
                                ),
                            }
                            mutate(body)
                        }}
                    >
                        انتقال وام
                    </div>
                </div>
                <div className=" w-full">
                    <div
                        onClick={() => navigate(-1)}
                        className=" mx-8 rounded-xl  bg-transparent text-green-1 text-center py-2.5 my-2 cursor-pointer border-1 border-green-1"
                    >
                        بازگشت
                    </div>
                </div>
            </div>
        </div>
    )
}
